// extracted by mini-css-extract-plugin
module.exports = {"container":"layout_container__3Id8H","content":"layout_content__1SDLU","main":"layout_main__3Tn13"};